var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-sheet',{attrs:{"color":"orange lighten-2"}},[_vm._v("Hello, world! I'm a simple v-sheet")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }